import { Button } from '@components/button';
import { IconTrash } from '@components/icons/trash';
import { hideModal, Modal, useModal } from '@components/modal';
import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { useScopedTranslate } from '@locale/translate';

import { useDeleteUserApp } from 'api/authentication/hooks';

export const useUserAppsRemoveModal = () => useModal(UserAppsRemoveModal);

export const UserAppsRemoveModal = ({ clientId }: { clientId: string }) => {
  const { t } = useScopedTranslate(locale);

  const onSuccess = () => {
    hideModal();
  };
  const deleteMutation = useDeleteUserApp({ onSuccess });

  return (
    <Modal>
      <Modal.SimpleHeader title={t('addUserApp')} />
      <Modal.Content>
        <Text text={t('areYouSure')} />
        <Text text={t('cannotUse')} />
        <Text text={t('cannotBeUndone')} color="elementRed100" />
      </Modal.Content>
      <Modal.Footer>
        <Stack space={4} orientation="horizontal" justify="flex-end">
          <Button variant="secondary" onClick={hideModal} text={t('core.cancel')} />
          <Button
            variant="primary-red"
            onClick={() => deleteMutation.mutate(clientId)}
            iconLeft={<IconTrash />}
            text={t('core.remove')}
          />
        </Stack>
      </Modal.Footer>
    </Modal>
  );
};

export const locale = {
  en: {
    addUserApp: 'Remove API key',
    areYouSure: 'Are you sure you want to remove this API key?',
    cannotUse: 'Anyone using this key will not be able to do so from now on.',
    cannotBeUndone: 'This can not be undone',
  },
};
